import React, { useEffect, useState } from 'react'
import Icons from 'assets/icons'
import Button from 'components/formElements/Button'
import DefaultSelect from 'components/formElements/DefaultSelect'
import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import { useRequest } from 'hooks/useRequest'
import { leadManagementProjectDurationTypeList, leadManagementStatus, leadManagementStatusList } from 'utils/Constants'
import useToast from 'hooks/useToast'
import { Dialog } from 'primereact/dialog'
import moment from 'moment'
import { getPermission } from 'utils/Auth'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Link, useNavigate } from 'react-router-dom'
import Spinner from 'components/loader/Spinner'
import { Dropdown } from 'primereact/dropdown'
import { InputTextarea } from 'primereact/inputtextarea'
import { InputNumber } from 'primereact/inputnumber'
import { MultiSelect } from 'primereact/multiselect'
import { currencyFormatter } from 'utils/CurrencyFormatter'

const LeadManagement = () => {
    const [filterOptions, setFilterOptions] = useState({
        searchString: '',
        sort: null,
        isArchive: false,
        am: [],
        pmo: [],
        status: leadManagementStatusList.map((s) => s.value).filter((s) => ![leadManagementStatus.rejected.value, leadManagementStatus.approved.value, leadManagementStatus.suspended.value].includes(s)),
        technologies: [],
        isFeatured: null
    })
    const [createModal, setCreateModal] = useState({ open: false, leadManagement: {} })
    const [getLeadManagement, getLeadManagementLoading] = useRequest()
    const [leadManagement, setLeadManagement] = useState([])
    const [filteredLeadManagement, setFilteredLeadManagement] = useState([])
    const [technologies, setTechnologies] = useState([])
    const [customers, setCustomers] = useState([])
    const [accountManagers, setAccountManagers] = useState()
    const [pmos, setPmos] = useState()
    const { showToast } = useToast()
    const navigate = useNavigate()
    const [request] = useRequest()

    useEffect(() => {
        request('/Account/GetAllUsers', { method: 'GET' }).then((res) => {
            if (res.data.ok) {
                setAccountManagers(res.data.result.filter((u) => u.roles?.find((r) => r.name === 'AccountManager'))
                    .map((u) => ({ label: `${u.firstName} ${u.lastName}`, value: u.id })))
                setPmos(res.data.result.filter((u) => u.roles?.every((r) => r.name === 'Administrator'))
                    .map((u) => ({ label: `${u.firstName} ${u.lastName}`, value: u.id })))
            }
        })

        request('/Technologies/GetAllTechnologies', { method: 'GET' }).then((res) => {
            if (res.data.ok) {
                setTechnologies(res.data.result.map((t) => ({ label: t.name, value: t.id })))
            }
        })
    }, [])

    useEffect(() => {
        if (!createModal.open) {
            getLeadManagement(
                '/LeadManagement/GetAllLeadManagements',
                { method: 'GET', params: { isArchive: filterOptions.isArchive } }
            ).then((res) => {
                if (res.data.ok) {
                    setLeadManagement(res.data.result.sort((a, b) => {
                        if (a.isFeatured && !b.isFeatured) {
                            return -1
                        } else if (!a.isFeatured && b.isFeatured) {
                            return 1
                        } else {
                            return (a.leadManagementCustomerName + ' - ' + a.projectName).localeCompare(b.leadManagementCustomerName + ' - ' + b.projectName, 'tr')
                        }
                    }))
                }
            })
        } else {
            request('/LeadManagement/GetLeadManagementCustomers', { method: 'GET' }).then((res) => {
                if (res.data.ok) {
                    setCustomers(res.data.result.map((c) => ({ label: c.name, value: c.id })))
                }
            })
        }
    }, [createModal, filterOptions.isArchive])

    useEffect(() => {
        let filtered = leadManagement.filter((l) => {
            let result = true

            if (filterOptions.searchString) {
                result &&= (`${l.leadManagementCustomerName} - ${l.projectName}`).toLocaleLowerCase('tr')
                    .includes(filterOptions.searchString.toLocaleLowerCase('tr'))
            }

            if (filterOptions.am?.length > 0) {
                result &&= filterOptions.am.find((am) => l.accountManagerUserId === am) != null
            }

            if (filterOptions.pmo?.length > 0) {
                result &&= filterOptions.pmo.find((pmo) => l.responsibleAdminUserId === pmo) != null
            }

            if (filterOptions.status?.length > 0) {
                result &&= filterOptions.status.find((s) => l.status === s) != null
            }

            if (filterOptions.technologies?.length > 0) {
                result &&= filterOptions.technologies.every((t) => l.leadManagementTechnologies.find((lt) => lt.technologyId === t) != null)
            }

            if (filterOptions.isFeatured != null) {
                result &&= l.isFeatured === filterOptions.isFeatured
            }

            return result
        })

        if (filterOptions.sort) {
            filtered = filtered.sort((a, b) => (filterOptions.sort === 1
                ? moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf()
                : moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf()))
        }

        setFilteredLeadManagement(filtered)
    }, [filterOptions, leadManagement])

    const handleCreate = () => {
        if (!createModal?.leadManagement?.leadManagementCustomerId && !createModal?.leadManagement?.newCustomerName) {
            showToast('Müşteri Adını Girin', 'error')
            return
        }

        if (!createModal?.leadManagement?.projectName) {
            showToast('Proje Adını Girin', 'error')
            return
        }

        if (!createModal?.leadManagement?.leadManagementTechnologies?.length) {
            showToast('Teknoloji Seçin', 'error')
            return
        }

        if (!createModal?.leadManagement?.accountManagerUserId) {
            showToast('Account Manager Seçin', 'error')
            return
        }

        if (!createModal?.leadManagement?.responsibleAdminUserId) {
            showToast('Sorumlu PMO Seçin', 'error')
            return
        }

        createModal.leadManagement.projectBudgetCurrency = createModal.leadManagement.projectBudget ? createModal.leadManagement.projectBudgetCurrency : null
        createModal.leadManagement.slaBudgetCurrency = createModal.leadManagement.slaBudget ? createModal.leadManagement.slaBudgetCurrency : null
        createModal.leadManagement.mdPriceCurrency = createModal.leadManagement.mdPrice ? createModal.leadManagement.mdPriceCurrency : null

        request('/LeadManagement/UpsertLeadManagement', {
            method: 'POST',
            data: createModal.leadManagement
        }).then((res) => {
            if (res.data.ok) {
                showToast('Proje Oluşturuldu', 'success')
                setCreateModal({ open: false, leadManagement: {} })
            }
        })
    }

    const handleFilterChange = (e, name) => {
        name = name || e.name
        let isArr = Array.isArray(e)
        let value = isArr ? e : e?.value

        if (e?.length === 0 || e?.value === '') {
            value = null
        }

        setFilterOptions((prev) => ({ ...prev, [name]: value }))
    }

    const handleChange = (e, name) => {
        if (name) {
            setCreateModal((prev) => ({ ...prev, leadManagement: { ...prev.leadManagement, [name]: e } }))
        } else {
            setCreateModal((prev) => ({ ...prev, leadManagement: { ...prev.leadManagement, [e.target.name]: e.target.value } }))
        }
    }

    return (
        <AnimatedSpan className='page-container d-flex flex-column'>
            {getLeadManagementLoading ? (
                <div className='d-flex w-100 justify-content-center'>
                    <Spinner size={3} />
                </div>
            ) : (
                <div className='row'>
                    <DataTable
                        stripedRows
                        className='col-md-12 p-1'
                        emptyMessage='Hiç Kayıt Bulunamadı'
                        size='normal'
                        responsiveLayout='stack'
                        dataKey='id'
                        header={() => (
                            <div className='row flex-1' style={{ rowGap: '10px' }}>
                                <div className='col-md-2'>
                                    <span className='p-input-icon-left '>
                                        <i className='pi pi-search' />
                                        {filterOptions.searchString &&
                                            <i className='pi pi-times' style={{ cursor: 'pointer', right: '10px' }} onClick={() => setFilterOptions({ ...filterOptions, searchString: '' })} />}
                                        <input
                                            type='text'
                                            placeholder='Proje Adı'
                                            className='default-input pl-5 pr-4'
                                            value={filterOptions.searchString}
                                            name='searchString'
                                            onChange={(e) => handleFilterChange(e.target)}
                                        />
                                    </span>

                                </div>
                                <div className='col-md-3'>
                                    <MultiSelect
                                        value={filterOptions.am}
                                        onChange={(e) => handleFilterChange(e, 'am')}
                                        options={accountManagers}
                                        optionLabel='label'
                                        optionValue='value'
                                        showClear
                                        placeholder='AM'
                                        style={{ width: '100%', overflow: 'hidden' }}
                                        showSelectAll={false}
                                        panelHeaderTemplate={() => <></>}
                                    />
                                </div>
                                <div className='col-md-3'>
                                    <MultiSelect
                                        value={filterOptions.pmo}
                                        onChange={(e) => handleFilterChange(e, 'pmo')}
                                        options={pmos}
                                        optionLabel='label'
                                        optionValue='value'
                                        showClear
                                        placeholder='PMO'
                                        style={{ width: '100%', overflow: 'hidden' }}
                                        showSelectAll={false}
                                        panelHeaderTemplate={() => <></>}
                                    />
                                </div>
                                <div className='col-md-2'>
                                    <DefaultSelect
                                        handleChange={(e) => handleFilterChange(e, 'isArchive')}
                                        placeholder='Arşiv'
                                        value={[
                                            { label: 'Arşiv(Evet)', value: true },
                                            { label: 'Arşiv(Hayır)', value: false }
                                        ].find((f) => f.value === filterOptions.isArchive)}
                                        selectOptions={[
                                            { label: 'Arşiv(Evet)', value: true },
                                            { label: 'Arşiv(Hayır)', value: false }
                                        ]}
                                    />
                                </div>
                                <div className='col-md-2'>
                                    <DefaultSelect
                                        placeholder='Sırala'
                                        value={[
                                            { label: 'Yeniden Eskiye', value: 1 },
                                            { label: 'Eskiden Yeniye', value: 2 }
                                        ].find((f) => f.value === filterOptions.sort)}
                                        selectOptions={[
                                            { label: 'Yeniden Eskiye', value: 1 },
                                            { label: 'Eskiden Yeniye', value: 2 }
                                        ]}
                                        handleChange={(e) => handleFilterChange(e, 'sort')}
                                        isClearable
                                    />
                                </div>
                                <div className='col-md-5'>
                                    <MultiSelect
                                        value={filterOptions.status}
                                        onChange={(e) => handleFilterChange(e, 'status')}
                                        options={leadManagementStatusList}
                                        optionLabel='label'
                                        optionValue='value'
                                        showClear
                                        placeholder='Durum'
                                        style={{ width: '100%', overflow: 'hidden' }}
                                    />
                                </div>
                                <div className='col-md-3'>
                                    <MultiSelect
                                        value={filterOptions.technologies}
                                        onChange={(e) => handleFilterChange(e, 'technologies')}
                                        options={technologies}
                                        optionLabel='label'
                                        optionValue='value'
                                        showClear
                                        placeholder='Teknoloji'
                                        style={{ width: '100%', overflow: 'hidden' }}
                                        showSelectAll={false}
                                        panelHeaderTemplate={() => <></>}
                                    />
                                </div>
                                <div className='col-md-2'>
                                    <DefaultSelect
                                        handleChange={(e) => handleFilterChange(e, 'isFeatured')}
                                        placeholder='Hot İşler'
                                        value={[
                                            { label: 'Evet', value: true },
                                            { label: 'Hayır', value: false }
                                        ].find((f) => f.value === filterOptions.isFeatured)}
                                        selectOptions={[
                                            { label: 'Evet', value: true },
                                            { label: 'Hayır', value: false }
                                        ]}
                                        isClearable
                                    />
                                </div>
                                <div className='col py-0'>
                                    <div className='filters-right d-flex justify-content-end'>
                                        {getPermission('LeadManagement.create') && (
                                            <Button handleClick={() => setCreateModal({ open: true, leadManagement: {} })} className='btn-success' title='Proje Oluştur' icon={<Icons.plus />} />
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                        rowClassName={`cursor-pointer table-hover`}
                        cellClassName={`text-sm p-2`}
                        onRowClick={(e) => {navigate(`${e.data.id}`)}}
                        paginator
                        alwaysShowPaginator={false}
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Toplam {totalRecords} kayıttan {first} - {last} arasındakiler gösteriliyor"
                        rows={25}
                        value={filteredLeadManagement}
                    >
                        <Column
                            headerClassName='text-bold bg-primary text-default'
                            className='text-semi-bold text-sm'
                            style={{ width: 'auto' }}
                            field='projectName'
                            sortable='true'
                            header='Proje Adı'
                            body={(rowData) => (
                                <div className='d-flex align-items-center gap-2'>
                                    {rowData.isFeatured && <Icons.hot size={18} color='#FC2E53' />}
                                    <span>{`${rowData.leadManagementCustomerName} - ${rowData.projectName}`}</span>
                                </div>
                            )}
                        />
                        <Column
                            headerClassName='text-bold bg-primary text-default'
                            className='text-semi-bold text-sm'
                            style={{ width: 'auto' }}
                            field='leadManagementTechnologies'
                            sortable='true'
                            sortFunction={e => {
                                let sortOrder = e.order
                                if (sortOrder === 0) {
                                    return e.data
                                }
                                return e.data.sort((data1, data2) => {
                                    let value1 = data1.leadManagementTechnologies?.map((t) => t.technologyName).sort().join(', ')
                                    let value2 = data2.leadManagementTechnologies?.map((t) => t.technologyName).sort().join(', ')
                                    let result = value1.localeCompare(value2, 'tr')
                                    return sortOrder * result
                                })
                            }}
                            header='Teknoloji'
                            body={(rowData) => rowData.leadManagementTechnologies?.map((t) => t.technologyName).sort().join(', ')}
                        />
                        <Column
                            headerClassName='text-bold bg-primary text-default'
                            className='text-sm'
                            field='accountManager'
                            sortable='true'
                            header='AM'
                            style={{ width: 'auto' }}
                            body={(rowData) => `${rowData.accountManager?.firstName} ${rowData.accountManager?.lastName}`}
                        />
                        <Column
                            headerClassName='text-bold bg-primary text-default'
                            className='text-sm'
                            field='pmo'
                            sortable='true'
                            header='PMO'
                            style={{ width: 'auto' }}
                            body={(rowData) => `${rowData.responsibleAdmin?.firstName} ${rowData.responsibleAdmin?.lastName}`}
                        />
                        <Column
                            headerClassName='text-bold bg-primary text-default'
                            className='text-sm'
                            field='projectDuration'
                            header='Proje Süresi'
                            style={{ width: '6rem' }}
                            body={(rowData) => (rowData.projectDuration ? `${rowData.projectDuration.toLocaleString('tr-TR', { maximumFractionDigits: 2 })} ${leadManagementProjectDurationTypeList.find((t) => t.value === rowData.projectDurationType)?.label}` : '-')}
                        />
                        <Column
                            headerClassName='text-bold bg-primary text-default'
                            className='text-sm'
                            field='projectBudget'
                            sortable='true'
                            header='Proje Bütçesi'
                            style={{ width: '10rem' }}
                            body={(rowData) => (rowData.projectBudget ? `${currencyFormatter(rowData.projectBudget)} ${rowData.projectBudgetCurrency}` : '-')}
                        />
                        <Column
                            headerClassName='text-bold bg-primary text-default'
                            className='text-semi-bold text-sm'
                            field='status'
                            sortable='true'
                            header='Durum'
                            style={{ width: '10rem' }}
                            body={(rowData) => leadManagementStatusList.find(p => p.value === rowData.status)?.label}
                        />
                        <Column
                            headerClassName='text-bold bg-primary text-default'
                            className='text-sm'
                            field='offerDate'
                            header='Hedef Teklif Tarihi'
                            sortable='true'
                            style={{ width: '10rem' }}
                            body={(rowData) => {
                                const offerDate = rowData?.offerDate && moment(rowData.offerDate)
                                const diff = offerDate && moment(new Date(), 'YYYY-MM-DD').diff(offerDate.format('YYYY-MM-DD'), 'days')
                                const isDone = [leadManagementStatus.rejected.value, leadManagementStatus.approved.value, leadManagementStatus.suspended.value].includes(rowData.status)
                                return (
                                    offerDate && (
                                        <span className={`projects-list-card-footer-period text-sm${diff > 0 && !isDone ? ' text-danger' : ''} `}>
                                            {offerDate.format('LL')}
                                        </span>
                                    )
                                )
                            }}
                        />
                        <Column
                            headerClassName='text-bold bg-primary text-default'
                            className='text-sm relative-cell'
                            field='reminderDate'
                            header='Hatırlatma Tarihi'
                            sortable='true'
                            style={{ width: '10rem' }}
                            body={(rowData) => {
                                const reminderDate = rowData?.reminderDate && moment(rowData.reminderDate)
                                const diff = reminderDate && moment(new Date(), 'YYYY-MM-DD').diff(reminderDate.format('YYYY-MM-DD'), 'days')
                                return (
                                    <>
                                        <Link target='_blank' className='new-page-link-icon' to={`/lead-management/${rowData.id}`}>
                                            <span>Yeni Pencerede Aç</span>{' '}
                                            <span onClick={(e) => e.stopPropagation()}>
                                                <Icons.arrowRight onClick={(e) => e.stopPropagation()} />
                                            </span>
                                        </Link>
                                        {reminderDate && (
                                            <span className={`projects-list-card-footer-period text-sm${diff > 0 ? ' text-danger' : ''} `}>
                                                {reminderDate.format('LL')}
                                            </span>
                                        )}
                                    </>
                                )
                            }}
                        />
                    </DataTable>
                </div>
            )}

            <Dialog style={{ width: '700px', maxWidth: '100%' }}
                    header='Proje Oluştur'
                    draggable={false}
                    visible={createModal.open}
                    onHide={() => setCreateModal({ open: false, leadManagement: {} })}>
                <div className='w-100'>
                    <div className='w-100 d-flex flex-column gap-3 mt-1'>
                        <div className='row'>
                            <div className='col-md-6'>
                                <Dropdown value={createModal.leadManagement?.leadManagementCustomerId || createModal.leadManagement?.newCustomerName}
                                          onChange={e => {
                                              if (!e.originalEvent) return
                                              let isId = Number.isInteger(e.value) && customers.find(c => c.value === e.value)
                                              setCreateModal((prev) => ({
                                                  ...prev,
                                                  leadManagement: {
                                                      ...prev.leadManagement,
                                                      leadManagementCustomerId: isId ? e.value : null,
                                                      newCustomerName: isId ? null : e.value
                                                  }
                                              }))
                                          }}
                                          onInput={e => {
                                              setCreateModal((prev) => ({ ...prev, leadManagement: { ...prev.leadManagement, leadManagementCustomerId: null, newCustomerName: e.target.value } }))
                                          }}
                                          options={customers}
                                          optionLabel='label'
                                          optionValue='value'
                                          placeholder={'Müşteri Adı'}
                                          filter
                                          filterLocale='tr'
                                          editable
                                          filterInputAutoFocus={false}
                                          className={'w-100'} />
                            </div>
                            <div className='col-md-6'>
                                <input
                                    className='default-input'
                                    type='text'
                                    placeholder='Proje Adı'
                                    name='projectName'
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12'>
                                <InputTextarea
                                    placeholder='Proje Özeti'
                                    name='projectDescription'
                                    onChange={handleChange}
                                    autoResize={true}
                                    style={{ width: '100%', maxHeight: '150px' }}
                                    rows={2}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12'>
                                <DefaultSelect
                                    isMulti
                                    handleChange={(e) => handleChange(e.map((t) => ({ technologyId: t.value })), 'leadManagementTechnologies')}
                                    placeholder='Teknolojiler'
                                    selectOptions={technologies}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-6'>
                                <DefaultSelect
                                    handleChange={(e) => handleChange(e.value, 'accountManagerUserId')}
                                    placeholder='Account Manager'
                                    selectOptions={accountManagers}
                                />
                            </div>
                            <div className='col-md-6'>
                                <DefaultSelect
                                    handleChange={(e) => handleChange(e.value, 'responsibleAdminUserId')}
                                    placeholder='Sorumlu PMO'
                                    selectOptions={pmos}
                                />
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='p-inputgroup'>
                                    <InputNumber
                                        mode={'decimal'}
                                        maxFractionDigits={2}
                                        minFractionDigits={0}
                                        min={0}
                                        placeholder='Proje Süresi'
                                        className={'flex-fill w-100'}
                                        onChange={(e) => handleChange(e.value, 'projectDuration')}
                                    />
                                    <Dropdown
                                        value={createModal.leadManagement?.projectDurationType || leadManagementProjectDurationTypeList[0].value}
                                        className={'w-auto'}
                                        onChange={(e) => handleChange(e.value, 'projectDurationType')}
                                        options={leadManagementProjectDurationTypeList}
                                        optionLabel='label'
                                        optionValue='value'
                                    />
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <Dropdown
                                    value={createModal.leadManagement?.isFeatured}
                                    onChange={(e) => handleChange(e.value, 'isFeatured')}
                                    options={[
                                        { label: 'Evet', value: true },
                                        { label: 'Hayır', value: false }
                                    ]}
                                    placeholder='Hot İşler'
                                    showClear
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12 d-flex justify-content-end gap-3'>
                                <Button className='btn-danger' title='Vazgeç' handleClick={() => setCreateModal({ open: false, leadManagement: {} })} />
                                <Button className='btn-success' title='Kaydet' handleClick={handleCreate} />
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </AnimatedSpan>
    )
}
export default LeadManagement
